import { DisplayItem, PcmCodeDivision } from '../../../../external/MasterDetailApi';
import { MessageInfo } from '../../../../external/MessageListApi';
import { MessageDisplayMethodInfo } from '../../../../external/MessageDisplayMethodListApi';
import { ItemImageInfo } from '../../../../external/MasterItemImageApi';
import { ProhibitedWordInfo } from '../../../../external/MasterProhibitedWordApi';

export interface MasterInfoState {
  messageList: Array<MessageInfo>;
  messageDisplayMethodList: Array<MessageDisplayMethodInfo>;
  displayItemList: Array<DisplayItem>;
  pcmCodeDivisionList: Array<PcmCodeDivision>;
  itemImageList: Array<ItemImageInfo>;
  prohibitedWordMstList: Array<ProhibitedWordInfo>;
}

export const initialMasterInfoState: MasterInfoState = {
  messageList: [],
  messageDisplayMethodList: [],
  displayItemList: [],
  pcmCodeDivisionList: [],
  itemImageList: [],
  prohibitedWordMstList: [],
};
